module.exports = __webpack_public_path__ + "img/healthcampaign.e30787ed.png";